import { render, staticRenderFns } from "./centerLensmanInfoData.vue?vue&type=template&id=88f48e36&scoped=true&"
import script from "./centerLensmanInfoData.vue?vue&type=script&lang=js&"
export * from "./centerLensmanInfoData.vue?vue&type=script&lang=js&"
import style0 from "./centerLensmanInfoData.vue?vue&type=style&index=0&id=88f48e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f48e36",
  null
  
)

export default component.exports